export default __webpack_public_path__ + "static/media/IconDesc_HadronCollider.256.e5e7c3d9.png";